export function formatDate(s: string | null) {
  if (!s) return "—";
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString();
}

export const RESERVATION_REASON_OPTIONS = [
  "custom",
  "trademark",
  "brand",
  "system",
  "route",
  "former_handle",
  "admin_rename_former",
  "reserved",
];
